import closedTradesReport from '@/views/manager-report/closed-trades-report';
import floatingPLReport from '@/views/manager-report/floatingpl-report';
import openTradesReport from '@/views/manager-report/open-trades-report';
import accountAnalyzeReport from '@/views/manager-report/account-analyze-report';
import symbolProfitReport from '@/views/manager-report/symbol-profit-report';
import profitTopList from '@/views/manager-report/profit-top-list';
import downloadReport from '@/views/manager-report/download-report';

import mt4ClosedTradesReport from '@/views/manager-report/mt4-closed-trades-report';
import mt4DepositWithdrawlReport from '@/views/manager-report/mt4-deposit-withdrawl-report';
import mt4CreditReport from '@/views/manager-report/mt4-credit-report';
import mt4SummaryReport from '@/views/manager-report/mt4-summary-report';
import mt4SeregatedReport from '@/views/manager-report/mt4-seregated-report';
import mt4EquityReport from '@/views/manager-report/mt4-equity-report';
import mt4EquityMultiReport from '@/views/manager-report/mt4-equity-multi-report';
import mt4ProfitLossReport from '@/views/manager-report/mt4-profitloss-report';
import mt4AccountReport from '@/views/manager-report/mt4-account-report';

const managerRouters = [
    { path: '/closedTradesReport', meta: { showInCrumb: true }, component: closedTradesReport },
    { path: '/floatingPLReport', meta: { showInCrumb: true }, component: floatingPLReport },
    { path: '/openTradesReport', meta: { showInCrumb: true }, component: openTradesReport },
    { path: '/accountAnalyzeReport', meta: { showInCrumb: true }, component: accountAnalyzeReport },
    { path: '/symbolProfitReport', meta: { showInCrumb: true }, component: symbolProfitReport },
    { path: '/profitTopList', meta: { showInCrumb: true }, component: profitTopList },
    { path: '/downloadReport', meta: { showInCrumb: true }, component: downloadReport },
    { path: '/mt4ClosedTradesReport', meta: { showInCrumb: true }, component: mt4ClosedTradesReport },
    { path: '/mt4DepositWithdrawlReport', meta: { showInCrumb: true }, component: mt4DepositWithdrawlReport },
    { path: '/mt4CreditReport', meta: { showInCrumb: true }, component: mt4CreditReport },
    { path: '/mt4SummaryReport', meta: { showInCrumb: true }, component: mt4SummaryReport },
    { path: '/mt4SeregatedReport', meta: { showInCrumb: true }, component: mt4SeregatedReport },
    { path: '/mt4EquityReport', meta: { showInCrumb: true }, component: mt4EquityReport },
    { path: '/mt4EquityMultiReport', meta: { showInCrumb: true }, component: mt4EquityMultiReport },
    { path: '/mt4ProfitLossReport', meta: { showInCrumb: true }, component: mt4ProfitLossReport },
    { path: '/mt4AccountReport', meta: { showInCrumb: true }, component: mt4AccountReport },
    { path: '/managerAuth', component: () => import('@/views/manager-report/check-manager.vue') },
]

export default managerRouters;


// WEBPACK FOOTER //
// ./src/router/manager-report/index.js